import React from "react";

function Services() {
  const data = [
    {
      title: "Institutional Projects",
      image: "/home1/assets/img/services/Untitled design - 400.png",
    },
    {
      title: "Residential Projects",
      image:
        "/home1/assets/img/services/Malathi-Exterior-06-scaled-e1765459078637.jpg",
    },
    {
      title: "Commercial Projects",
      image: "/home1/assets/img/services/1-1.png",
    },
    {
      title: "Industrial | Logistics & Warehousing",
      image: "/home1/assets/img/services/industrial.jpeg",
    },
    {
      title: "Warehousing Projects",
      image: "/home1/assets/img/services/industrial.jpeg",
    },
    {
      title: "More Projects",
      image: "/home1/assets/img/services/1-1.png",
    },
  ];

  return (
    <section
      style={{
        padding: "40px",
      }}
    >
      <h2
        style={{
          color: "#0f0f0f",
          textAlign: "center",
          marginBottom: "40px",
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
      >
        Our Projects
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "20px",
        }}
      >
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              position: "relative",
              overflow: "hidden",

              /* 🔥 SHARP CORNER FIX */
              borderRadius: "0",

              cursor: "pointer",
              height: "250px",
              transition: "all 0.3s ease",
              boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.querySelector("img").style.transform =
                "scale(1.08)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.querySelector("img").style.transform =
                "scale(1)";
            }}
          >
            {/* IMAGE */}
            <img
              src={item.image}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",

                /* 🔥 ENSURE NO ROUND */
                borderRadius: "0",

                transition: "transform 0.5s ease",
              }}
            />

            {/* OVERLAY */}
            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                padding: "15px",
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.3), transparent)",
                color: "#fff",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "16px",
                  fontWeight: "500",
                  letterSpacing: "0.5px",
                }}
              >
                {item.title}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;